module.exports = __webpack_public_path__ + "img/dundrum_small.bd7e2a7e.png";